
import type { SVGProps } from 'react';
const SvgPai = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    {...props}
  >
    <g clipPath="url(#pai_svg__a)">
      <path
        fill="#263E6A"
        d="M12.298 16.153a.51.51 0 0 1-.397-.193l-3.905-4.793a.367.367 0 0 1 .568-.463l3.728 4.576 8.004-10.416a.366.366 0 1 1 .581.447l-8.174 10.638a.51.51 0 0 1-.398.204zm8.242-3.883c0-.824-.12-1.636-.359-2.416a.366.366 0 1 0-.7.214c.216.71.326 1.45.326 2.202 0 4.156-3.381 7.537-7.537 7.537s-7.537-3.381-7.537-7.537 3.381-7.537 7.537-7.537c1.5 0 2.95.44 4.19 1.271a.366.366 0 1 0 .409-.608A8.23 8.23 0 0 0 12.269 4C7.71 4 4 7.71 4 12.27s3.71 8.27 8.27 8.27 8.27-3.71 8.27-8.27"
      />
    </g>
    <defs>
      <clipPath id="pai_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgPai;
